import {
  DialogBody,
  DialogFooter,
  DialogFooterActions,
} from '_core/dialogs/dialog';
import { FinalForm } from '_core/final-form/finalForm';
import { DialogForm } from '_core/forms/dialogForm';
import { FormErrors } from '_core/forms/formErrors';
import { SelectInFormGroupForFinalForm } from '_core/inputs/select';
import { Button, Intent } from '@blueprintjs/core';
import { SubmissionErrors } from 'final-form';
import { bankToOption, IBank } from 'invoices/types';
import * as React from 'react';

export interface IApproveDialogFormValues {
  bank: string;
}

interface IProps {
  banks: IBank[];
  initialValues: IApproveDialogFormValues;
  isOpen: boolean;
  onClose: () => void;
  onClosed: () => void;
  onSubmit: (
    values: IApproveDialogFormValues
  ) => Promise<SubmissionErrors | void>;
}

export function InvoicesApproveDialogForm({
  banks,
  initialValues,
  isOpen,
  onClose,
  onClosed,
  onSubmit,
}: IProps) {
  return (
    <FinalForm initialValues={initialValues} onSubmit={onSubmit}>
      {({ error, handleSubmit, submitError, submitting }) => (
        <DialogForm
          isOpen={isOpen}
          title="Выберите банк"
          onClose={onClose}
          onClosed={onClosed}
          isSubmitting={submitting}
          onSubmit={handleSubmit}
        >
          <DialogBody>
            <FormErrors error={error || submitError} />

            <SelectInFormGroupForFinalForm
              id="bank"
              name="bank"
              options={banks.map(bankToOption)}
              withEmptyOption
            />
          </DialogBody>

          <DialogFooter>
            <DialogFooterActions>
              <Button text="Отмена" onClick={onClose} />

              <Button
                disabled={submitting}
                intent={Intent.PRIMARY}
                loading={submitting}
                text="Ок"
                type="submit"
              />
            </DialogFooterActions>
          </DialogFooter>
        </DialogForm>
      )}
    </FinalForm>
  );
}
